const INITIAL_STATE = {
    toggle : false
 };
 
 export default function (state = INITIAL_STATE, action) {
     switch (action.type) {
         case 'togglechange':
             return {
                 ...state,
                 toggle : action.payload
            }
        default:
             return {
                 ...state
        }
     }
 }
 


// WEBPACK FOOTER //
// ./src/redux/reducers/Header.js